import { MessageCircle, Phone, ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { WhatsAppIcon } from "./Icons";
import { useSettings, waLink, openChat } from "../lib/site";

const spot = (e) => {
  const r = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--x", `${e.clientX - r.left}px`);
  e.currentTarget.style.setProperty("--y", `${e.clientY - r.top}px`);
};

const Card = ({ icon: Icon, title, text, cta, dark, testid, ...props }) => {
  const Tag = props.href ? "a" : "button";
  return (
    <Tag data-testid={testid} onMouseMove={spot} {...props} className={`group relative flex min-h-[300px] flex-col justify-between overflow-hidden rounded-[2rem] p-8 text-left transition-transform duration-500 hover:-translate-y-1 md:p-10 ${dark ? "bg-[var(--ink)] text-[var(--cream)]" : "border border-[var(--gold)]/25 bg-white/60"}`}>
      <span className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100" style={{ background: "radial-gradient(320px circle at var(--x) var(--y), rgba(201,164,92,.28), transparent 70%)" }} />
      <span className={`relative grid h-14 w-14 place-items-center rounded-full ${dark ? "bg-[var(--gold)] text-[var(--ink)]" : "bg-[var(--blush)]"}`}><Icon className="h-6 w-6" size={22} /></span>
      <div className="relative">
        <h3 className="font-display text-3xl">{title}</h3>
        <p className={`mt-3 text-sm leading-relaxed md:text-base ${dark ? "text-[var(--nude)]" : "text-[var(--ink-soft)]"}`}>{text}</p>
        <span className="mt-6 inline-flex items-center gap-2 text-sm font-medium">{cta}<ArrowUpRight size={16} className="transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" /></span>
      </div>
    </Tag>
  );
};

export const Contact = () => {
  const s = useSettings();
  return (
    <section id="contatti" data-testid="contact-section" className="bg-[#F1E4DC] py-24 md:py-36">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <SectionHead num="04" eyebrow="Contatti & prenotazioni" title={<>Scrivici, <em className="gold-text italic">ti rispondiamo</em> noi.</>} intro="Informazioni, preventivi o un appuntamento: usa la chat del sito, WhatsApp o chiamaci direttamente." />
        <div className="mt-14 grid gap-5 md:grid-cols-3">
          <Reveal><Card testid="contact-chat-card" icon={MessageCircle} dark title="Chat live" text="Scrivi direttamente dal sito: ricevi la risposta qui, senza lasciare la pagina." cta="Apri la chat" onClick={openChat} /></Reveal>
          <Reveal delay={0.08}><Card testid="contact-whatsapp-card" icon={WhatsAppIcon} title="WhatsApp" text={`Messaggio diretto al ${s.phone}. Ideale per inviarci foto di riferimento.`} cta="Scrivi su WhatsApp" href={waLink(s)} target="_blank" rel="noreferrer" /></Reveal>
          <Reveal delay={0.16}><Card testid="contact-phone-card" icon={Phone} title="Telefono" text={`Preferisci parlare a voce? Chiamaci al ${s.phone}.`} cta="Chiama ora" href={`tel:+39${s.phone.replace(/\D/g, "")}`} /></Reveal>
        </div>
      </div>
    </section>
  );
};
